module.exports = __webpack_public_path__ + "static/media/paper-plane-regular.8b299091.svg";